/**-------------------------------  Copyright ---------------------------------
This software has been developed by Orange Labs TGI/OLS/SOFT
Copyright (c) Orange Labs 2018

COPYRIGHT    : This file is the property of Orange Labs.
Copyright Orange Labs 2018, All Rights Reserved

This software is the confidential and proprietary information of Orange Labs.

You shall not disclose such Confidential Information and shall use it only
in accordance with the terms of the license agreement you entered into with
Orange Labs.

AUTHORS      : Orange Labs  TGI/OLS/SOFT
EMAIL        : soft.cybersec@orange.com
-----------------------------------------------------------------------------*/


export const NOT_AVAILABLE = 'N/A'
export const POLLING_INTERVAL = 5 // seconds
export const API_BASE_PATH = '/api/v1'
export const OSVERSION_URL = '/os_versions'
export const DEFAULT_OSVERSION = { osVersion: 'android-25', description: 'Nougat (API 25)'}
export const DEFAULT_VISIBILITY = 'public'
export const VISIBILITY_LIST = ['public', 'private']
export const INVALID_VALUE_GUI_MARK = '?'
export const SUCCESS_MESSAGE_TYPE = 'success'
export const ERROR_MESSAGE_TYPE = 'danger'
export const INFO_MESSAGE_TYPE = 'info'
export const HTTP_LONG_TIMEOUT = 240000 // milliseconds
